<template>
  <div>
    <b-form-select v-model="recipe_id" class="mb-1 mt-2 form-select-lg w-100" @change="$emit('getRecipeId', recipe_id)">
      <template #first>
        <b-form-select-option :value="null" disabled>-- Продукт --</b-form-select-option>
      </template>
      <b-form-select-option style="font-family: 'Roboto Slab'" v-b-scrollspy v-for="item in product.data" :key="item.recipe_id" :value="item.recipe_id" :label="item.product.name">
        {{item.product.name}}
      </b-form-select-option>
    </b-form-select>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

export default {
  name: "InputSelectProduct",
  data(){
    return{
      recipe_id: null,
    }
  },
  computed: {
    ...mapGetters(['product']),

  },

  methods: {
    ...mapActions(['loadProducts']),

  }
}
</script>

<style scoped>

</style>